module.exports = __webpack_public_path__ + "static/e60191.jpg";